import { ChangeDetectionStrategy, Component, OnDestroy, AfterViewInit } from '@angular/core';
import { RolesFieldsService } from './roles.fields.service';
import {
	AlarisComplexTableComponent,
	AlarisDialogService,
	AlarisLocalStorageService,
	AlarisTableStateService,
	EditPanelWidth,
	RowActionSimple,
	TABLE_STATE_SERVICE_INJECTOR
} from '@campaign-portal/components-library';
import { Role } from '@helpers/types/models';
import { TableSettingsService } from '@helpers/api/table-settings.service';
import { TableTypes } from '@campaign-portal/namespace/entities/table-settings/specs';
import { Paging } from '@campaign-portal/namespace/common/rpc.params';
import { RolesService } from './roles.service';
import { RolesDeleteDialogComponent } from './dialog/dialog.component';
import { BehaviorSubject } from 'rxjs';
import { EditRoleComponent } from './edit-role/edit-role.component';
import { STORAGE } from '@helpers/types/consts';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UserService } from '../../auth/user.service';

@Component({
	selector: 'app-roles',
	templateUrl: './roles.component.html',
	styleUrl: '../../../../node_modules/@campaign-portal/components-library/src/assets/templates/table-complex/complex-table.component.scss',
	providers: [
		AlarisTableStateService,
		{ provide: TABLE_STATE_SERVICE_INJECTOR, useExisting: AlarisTableStateService }
	],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class RolesComponent extends AlarisComplexTableComponent<Role> implements OnDestroy, AfterViewInit {

	override readonly rowActions: RowActionSimple<any>[] = [
		{
			icon: 'icon-edit',
			label: 'actions.edit',
			action: this.edit.bind(this),
			disabled: (): boolean => {
				return !this.user.allowed(['roles.edit'])
			}
		},
		{
			icon: 'icon-delete',
			label: 'actions.delete',
			action: this.delete.bind(this),
			highlight: true,
			separator: true,
			disabled: (): boolean => {
				return !this.user.allowed(['roles.edit'])
			}
		}
	];
	override readonly dblClickRowAction = this.edit;
	override pageSize = parseInt(this.storage.get(STORAGE.PAGE_SIZE) ?? '25', 10);
	override readonly pageSizeOptions = [25, 50, 100, 200];
	override readonly paging: Paging = {
		Skip: this.activePage,
		Take: this.pageSize
	};

	readonly exporting$ = new BehaviorSubject<boolean>(false);

	constructor(
		dataService: RolesService,
		fieldsService: RolesFieldsService,
		tableSettingsService: TableSettingsService,
		private readonly storage: AlarisLocalStorageService,
		private readonly dialog: AlarisDialogService,
		private readonly rolesService: RolesService,
		protected readonly user: UserService
	) {
		super(
			dataService,
			fieldsService,
			tableSettingsService,
			TableTypes.INTERNAL
		);
	}

	override ngOnDestroy(): void {
		super.ngOnDestroy();
		this.exporting$.next(false);
		this.exporting$.complete();
	}

	edit(role?: Role): void {
		this.editPanel.open<EditRoleComponent, { role: Role }, boolean>(EditRoleComponent, EditPanelWidth.SM, { role })
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe((result) => {
				if ( result ) {
					this.load();
				}
			});
	}

	delete(role: Role): void {
		this.dialog.open<boolean>(RolesDeleteDialogComponent, { autoFocus: false, data: { role } })
			.closed
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe((result) => {
				if ( result ) {
					this.load();
				}
			});
	}

	export(): void {
		this.exporting$.next(true);
		this.rolesService.export(this.total)
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe(() => {
				this.exporting$.next(false);
			});
	}

	override ngAfterViewInit(): void {
		super.ngAfterViewInit();
		this.rolesService.getPermissions()
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe(() => {
				this.setRefBooksInFields({
					Permissions: { list$: new BehaviorSubject<string[]>(this.rolesService.permissions) }
				});
			});
	}

}
